/**
 * Checks if an ISO string is a timezoned date.
 */

import { isValidDateString } from "@lib/isValidDateString";

export const isTimezoneDate = (date: string) => {
  if (!isValidDateString(date)) {
    return false;
  }

  return (
    date.endsWith("Z") || date.endsWith("+00:00") || date.endsWith("-00:00")
  );
};
;
import "/Users/andrejakogovsek/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";